import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';

import {loadGrid, loadGridFailure, loadGridSuccess} from '../actions/grid.actions';
import {MultiviewView} from '../../../services/api/multiviews/multiview.view.model';
import {MultiviewsService} from '../../../services/api/multiviews/multiviews.service';
import {WebSocketsUnregisteredService} from '../../../services/api/web-socket-connections/web-sockets.unregistered.service';


@Injectable()
export class GridEffects {

  // noinspection JSUnusedGlobalSymbols
  loadMultiview$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadGrid),
      concatMap((payload) =>
        this.multiviewsService.getMultiview(payload.data)
          .pipe(
            map((data: MultiviewView | any) => {
              const isWrapped: boolean = !!data?.data || false;
              if (isWrapped) {
                return loadGridSuccess({data: data.data});
              }

              return loadGridSuccess({data: data});
            }),
            catchError(error => of(loadGridFailure({error})))
          )
      )
    );
  });

  // noinspection JSUnusedGlobalSymbols
  onLoadMultiviewSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadGridSuccess),
      tap((payload: { data: MultiviewView }): void => {
        const multiview: MultiviewView = payload.data;
        if (multiview.id) {
          const id: UUID = multiview.id;
          this.webSocketService.subscribeToMultiview(id);
        }
      })
    );
  }, {dispatch: false});


  constructor(
    private readonly actions$: Actions,
    private readonly multiviewsService: MultiviewsService,
    private readonly webSocketService: WebSocketsUnregisteredService
  ) {
  }

}
